import { createRouter, createMemoryHistory } from 'vue-router'
import MainProducts from '../features/MainProducts/index.ts'
import Options from '../features/Options/OptionsBase/index.ts'
import Configs from '../features/Configs/ConfigsBase/index.ts'
import CustomerDataBase from '../features/CustomerData/CustomerDataBase/index.ts'
import CompletionBase from '../features/Completion/CompletionBase/index.ts'
import ConfirmationBase from '../features/Confirmation/ConfirmationBase/index.ts'

const routes = [
  { path: '', name: 'products', component: MainProducts },
  { path: '/options', name: 'options', component: Options },
  { path: '/options/access', name: 'options_access', component: Options },
  { path: '/options/phone', name: 'options_phone', component: Options },
  { path: '/options/tv', name: 'options_tv', component: Options },
  { path: '/options/mobile', name: 'options_mobile', component: Options },
  { path: '/configs', name: 'configs', component: Configs },
  { path: '/configs/access', name: 'configs_access', component: Configs },
  { path: '/configs/phone', name: 'configs_phone', component: Configs },
  { path: '/configs/tv', name: 'configs_tv', component: Configs },
  { path: '/configs/mobile', name: 'configs_mobile', component: Configs },
  { path: '/customerdata', name: 'customerdata', component: CustomerDataBase },
  { path: '/completion', name: 'completion', component: CompletionBase },
  { path: '/confirmation', name: 'confirmation', component: ConfirmationBase },
]

const router = createRouter({
  history: createMemoryHistory(),
  routes,
})

export default router
